var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgUnifiedContactsCe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500.4 485",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        letter-spacing: .07em;\n      }\n\n      .cls-2 {\n        font-family: MiriamLibre-Regular, 'Miriam Libre';\n        font-size: 101px;\n      }\n\n      .cls-3 {\n        fill: #9898f9;\n      }\n\n      .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-4 {\n        fill: #008087;\n      }\n\n      .cls-5 {\n        letter-spacing: .08em;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2-2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m428.5,77.1h0L0,0l72.9,485,261.8-100.9h0c-12.3-2.1-20.4-3.9-31.7-10.1-14.3-9.2-25.6-20.5-33.9-35-8.3-14.3-12.3-30.9-12.3-47.3v-75.9c0-17.5,4.1-32.9,12.3-47.3,2.1-3.6,4.3-7.1,6.8-10.3,7.5-10.8,16.8-19.2,28.1-25.6,14.3-8.3,29.8-12.3,46.3-12.3,14.3,0,28.8,3,41.1,8.3,12.3,5.1,22.6,13.4,31.8,23.7,1,2.1,2.1,4.1,2.1,6.2s-1,5.1-3,7.2l-15.4,16.4s-.1,0-.2.1l-.8.9c-1,1-3,2.1-5.1,2.1s-4.1-1-6.2-3c-11.3-12.3-25.6-19.6-44.2-19.6-9.2,0-17.5,2.1-24.7,7.2-4,2.9-7.7,6.2-11.2,9.9-2.6,3-5,6.3-7.3,9.6-5,8-7.1,16.1-7.2,25.2v76.6c0,9.2,3,17.5,7.2,25.6,5.1,8.3,11.3,14.3,18.5,19.6,7.2,5.2,15.4,7.2,24.7,7.2,17.5,0,32.9-6.2,44.2-18.5,2.1-2.1,4.1-3,6.2-3s4.1,1,6.2,3l15.4,16.4c2.1,2.1,3,4.1,3,7.2v3c-.1.4-.4.7-.6.9l2.4-.8h0l73.2-27.7-71.9-246.9ZM52.6,284.6v-151c0-2.1,1-4.1,2.1-5.1,1-1,3-2.1,5.1-2.1h29.8c2.1,0,4.1,1,5.1,2.1,1,1,2.1,3,2.1,5.1v153.1c0,16.4,5.1,30.9,14.3,41.1,9.1,10.1,21.3,15.2,36.5,15.3,15.2-.1,27.4-5.2,36.5-15.3,9.2-10.3,14.3-24.7,14.3-41.1v-153.1c0-2.1,1-4.1,2.1-5.1,1.1-1,3-2.1,5.1-2.1h29.8c2.1,0,4.1,0,5.1,2.1,1,1,2.1,3,2.1,5.1v151c0,19.6-4.1,36.9-12.3,52.4-8.3,15.4-19.6,27.7-33.9,36-14.3,9.2-30.9,13.4-48.2,13.4-18.5,0-35-4.1-49.3-13.4-14.3-8.3-25.6-20.5-33.9-36-8.4-15.5-12.4-33-12.4-52.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 330.49,
    y: 0.2,
    width: 166.61,
    height: 114.5
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(352.78 94.28)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 0,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 62.32,
    y: 0
  }, "E"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgUnifiedContactsCe);
export default __webpack_public_path__ + "static/media/svg_Unified-Contacts-CE.f6fa04f53c60b615b665898d1bc867df.svg";
export { ForwardRef as ReactComponent };